const StringConstants = {
  GET: 'get',
  PUT: 'put',
  POST: 'post',
  DELETE: 'delete',
  MISSING_PARAM: 'missing param',

  // direction
  NEXT: 'next',
  PREV: 'prev',

  FORMATTED_BRAND_NAMES: {
    hotpads: 'HotPads',
    zillow: 'Zillow',
    trulia: 'Trulia',

    // external
    // eslint-disable-next-line constellation/word-list
    realtor: 'Realtor',
    rent: 'Rent',
    apartmentGuide: 'ApartmentGuide',
    redfin: 'Redfin',
  },

  // using the plain brand names for hotpads and trulia for now whenever we need to use ZRM brand for zillow
  FORMATTED_BRAND_NAMES_RENTAL: {
    hotpads: 'HotPads',
    zillow: 'Zillow Rental Manager',
    trulia: 'Trulia',

    // external
    // eslint-disable-next-line constellation/word-list
    realtor: 'Realtor',
    rent: 'Rent',
    apartmentGuide: 'ApartmentGuide',
    redfin: 'Redfin',
  },

  UNFORMATTED_BRAND_NAMES: {
    hotpads: 'hotpads',
    zillow: 'zillow',
    trulia: 'trulia',

    // external
    // eslint-disable-next-line constellation/word-list
    realtor: 'realtor',
    rent: 'rent',
    apartmentGuide: 'apartmentGuide',
    redfin: 'redfin',
  },

  GA_TRACKERS: {
    dsp: 'dsp',
    gtm: 'gtm',
    zillow: 'zillow',
  },

  REDIRECT_TO: {
    PAYMENTS: 'payments',
  },

  ALLOW_PARAMS_REGEX: '([?].*)?([&].*)?',
  ALLOW_DASHBOARD_PARAMS_REGEX: '(overview|listing)',

  // server side error string identifier
  // only for BE status code > 399 that are to be fixed in near future
  SS_ERRORS: {
    // FE check and message
    invalid_email_address: 'Not a valid email address',
    invalid_phone_number: 'Not a valid 10 digit phone number',

    // BE code
    attempt_limit_reached: 'attempt-limit-reached',
    confirm_phone: 'confirm-phone',
    email_verification_pending: 'email-verification-pending',
    email_verification_required: 'email-verification-required',
  },

  MOBILE_PLATFORMS: {
    ANDROID: 'android',
    IOS: 'ios',
  },

  ERROR: 'Error',
} as const;

export type RestMethodNameProps =
  | typeof StringConstants.GET
  | typeof StringConstants.PUT
  | typeof StringConstants.POST
  | typeof StringConstants.DELETE;

export default StringConstants;
